// src/pages/Policies.jsx
import React, { useState } from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import PoliciesList from '../components/policies/PoliciesList';
import PolicyDetail from '../components/policies/PolicyDetail';
import PolicyForm from '../components/policies/PolicyForm';

const Policies = () => {
  const [filters, setFilters] = useState({
    policy_type: '',
    is_enabled: ''
  });
  const location = useLocation();
  
  // Only show filters on the main list view
  const showFilters = location.pathname === '/policies';

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const resetFilters = () => {
    setFilters({ policy_type: '', is_enabled: '' });
  };

  return (
    <div>
      <div className="px-4 py-5 sm:px-6">
        <div className="flex justify-between items-center">
          <div>
            <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
              Security Policies
            </h2>
            <p className="mt-1 text-sm text-gray-500">
              Define and manage security policies to protect your OT assets.
            </p>
          </div>
          {showFilters && (
            <Link
              to="/policies/new"
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              <svg className="mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
              </svg>
              Create Policy
            </Link>
          )}
        </div>
      </div>
      
      {showFilters && (
        <div className="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6 mb-6">
          <div className="md:flex md:items-center">
            <div className="md:w-1/4 mr-4">
              <label htmlFor="policy_type" className="block text-sm font-medium text-gray-700">
                Policy Type
              </label>
              <select
                id="policy_type"
                name="policy_type"
                value={filters.policy_type}
                onChange={handleFilterChange}
                className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
              >
                <option value="">All Types</option>
                <option value="NetworkTraffic">Network Traffic</option>
                <option value="BehavioralAnalysis">Behavioral Analysis</option>
                <option value="Firewall">Firewall</option>
                <option value="IDPS">IDPS</option>
                <option value="Authentication">Authentication</option>
                <option value="Custom">Custom</option>
              </select>
            </div>
            
            <div className="md:w-1/4 mt-4 md:mt-0">
              <label htmlFor="is_enabled" className="block text-sm font-medium text-gray-700">
                Status
              </label>
              <select
                id="is_enabled"
                name="is_enabled"
                value={filters.is_enabled}
                onChange={handleFilterChange}
                className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
              >
                <option value="">All</option>
                <option value="true">Enabled</option>
                <option value="false">Disabled</option>
              </select>
            </div>
            
            <div className="mt-4 md:mt-0 md:ml-6 md:flex-shrink-0">
              <button
                type="button"
                onClick={resetFilters}
                className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Reset Filters
              </button>
            </div>
          </div>
        </div>
      )}
      
      <Routes>
        <Route index element={<PoliciesList filters={filters} />} />
        <Route path=":policyId" element={<PolicyDetail />} />
        <Route path="new" element={<PolicyForm mode="create" />} />
        <Route path=":policyId/edit" element={<PolicyForm mode="edit" />} />
      </Routes>
    </div>
  );
};

export default Policies;
